export const SET_ORDERS_FILTER = 'SET_ORDERS_FILTER';

export const SET_PRODUCTS_FILTER = 'SET_PRODUCTS_FILTER';
